export class InventoryCountTagSummaryDto {
    countSap = 0;
    countQuantum = 0;
    diferences = 0;
    countTPV = 0;
    diferencesTPV = 0;
}
